import Ministry_of_Health from '../assets/Ministry of Health.jpg';
import MCIT from '../assets/MCIT.jpg';
import Cairoscan  from '../assets/Cairoscan.jpg';
import alfascan  from '../assets/alfascan.png';
import moh_eg  from '../assets/moh-eg.jpg';
import biomed_1  from '../assets/biomed-1.jpg';
import andalusia  from '../assets/andalusia.jpg';
import sanad  from '../assets/sanad.jpg';
import udh  from '../assets/udh.jpg';
import nilescan  from '../assets/nilescan.png';
import technoscan  from '../assets/technoscan.png';
// import userHolder  from '../assets/userHolder.jpg';
import cus_1 from '../assets/cus_1.png'
import cus_2 from '../assets/cus_2.png'
import cus_4 from '../assets/cus_4.png'




export const customers = [
    {
        title : 'Ministry of Health , kenya',
        img : Ministry_of_Health,
        description : 'Ministry of Health, Kenya is starting MILLENSYS Unified e-Health platform all over the county hospitals',
    },
    {
        title : 'MCIT',
        img : MCIT,
        description : 'MILLENSYS awarded a national telemedicine project with the Ministry of Communication and Information Technology " MCIT " in Egypt in more than 100 hospitals , 2018',
    },
    {
        title : 'Cairo Scan',
        img : Cairoscan,
        description : 'Cairo Scan Radiology Centers, Cairo, Egypt, is running MILLENSYS RIS and PACS platform in all its sites since 2011.',
    },
    {
        title : 'Alfa Scan',
        img : alfascan,
        description : 'Alfa Scan Radiology Centers, Cairo, Egypt, is running MILLENSYS RIS and ERP platform in all its sites since 2015 .',
    },
    {
        title : 'Ministry of Health , Egypt',
        img : moh_eg,
        description : 'More than 60 hospitals running MILLENSYS RIS / PACS and teleradiology applications at Ministry of Health of Egypt',
    },
    {
        title : 'Biomed medical hospitals , Greece',
        img : biomed_1,
        description : 'More than 40   Hospitals in Greece are running MILLENSYS PACS in all its sites since 2013',
    },
    {
        title : 'andalusia hospital , jeddah , saudi arabia',
        img : andalusia,
        description : 'Andalusia Hospital in Jeddah , Saudi Arabia is running MILLENSYS RIS / PACS solution since 2008',
    },
    {
        title : 'sanad hospital , jeddah , saudi arabia',
        img : sanad,
        description : 'Sanad Hospital in Riyadh is running MILLENSYS  PACS since 2014',
    },
    {
        title : 'udh , jeddah , saudi arabia',
        img : udh,
        description : 'United Doctors Hospital in Jeddah  is running MILLENSYS PACS since 2012',
    },
    {
        title : 'NileScan radiology centers , cairo , Egypt',
        img : nilescan,
        description : 'Nile Scan Radiology Centers, Cairo, Egypt,  is running MILLENSYS unified diagnostic platform &quot; RIS , PACS and ERP &quot; in all its sites starting from 2016',
    },
    {
        title : 'Techno Scan radiology centers , cairo , Egypt',
        img : technoscan,
        description : 'Technoscan Radiology Centers , Cairo, Egypt, is running MILLENSYS RIS in all its sites starting from 2015',
    },
]
export const customersFeedback = [
    {
        name : 'Dr Abdelkader Bentria',
        title : 'Founder of DIAGNOOR SCANLAB',
        img : cus_1,
        description : `Millensys' web-based RIS, PACS, and ERP transformed my workflow. Remote access through teleradiology empowers me to serve more patients, all thanks to a streamlined system.`,
    },
    {
        name : 'Dr Foued Otmani',
        title : 'Co-founder of CIM RIM',
        img : cus_2,
        description : `Since 2015, Millensys has been a trusted partner for our healthcare facility. Their RIS, PACS, and ERP solution has delivered exceptional quality, and their commitment to unconditional support has been invaluable. Most recently, our successful upgrade seamlessly integrated new modules while preserving years of patient data. This combination of innovation and reliability makes Millensys a true partner in delivering the best care possible.`,
    },
    // {
    //     name : 'Dr. Nour',
    //     title : ' ',
    //     img : userHolder,
    //     description : `Initially, we encountered some unfinished functionalities that caused concern. However, Millensys' commitment to customer satisfaction shone through. Their dedication to a successful upgrade and data migration impressed us. Now, the web-based RIS, PACS, and MiAnalytics solution offers seamless access to information, a holistic view of our activity, and valuable decision-support tools. Millensys truly listens and delivers.`,
    // },
    {
        name : 'Prof. Magdy Bassiouni',
        title : 'Professor Emeritus of Radiology, Cairo Univ',
        img : cus_4,
        description : `For the past decade, Millensys' RIS and PACS have been the backbone of our radiology department. Writing reports is a breeze thanks to their user-friendly interface, and their top-notch support team is always there to answer any questions.  Millensys is a reliable partner we can count on`,
    },
    // {
    //     name : 'Dr Abdelkader Bentria',
    //     title : 'Founder of DIAGNOOR SCANLAB',
    //     img : cus_1,
    //     description : `Millensys' web-based RIS, PACS, and ERP transformed my workflow. Remote access through teleradiology empowers me to serve more patients, all thanks to a streamlined system.`,
    // },
    // {
    //     name : 'Dr Foued Otmani',
    //     title : 'Co-founder of CIM RIM',
    //     img : cus_2,
    //     description : `Since 2015, Millensys has been a trusted partner for our healthcare facility. Their RIS, PACS, and ERP solution has delivered exceptional quality, and their commitment to unconditional support has been invaluable. Most recently, our successful upgrade seamlessly integrated new modules while preserving years of patient data. This combination of innovation and reliability makes Millensys a true partner in delivering the best care possible.`,
    // },
    // {
    //     name : 'Dr. Nour',
    //     title : 'COE',
    //     img : userHolder,
    //     description : `Initially, we encountered some unfinished functionalities that caused concern. However, Millensys' commitment to customer satisfaction shone through. Their dedication to a successful upgrade and data migration impressed us. Now, the web-based RIS, PACS, and MiAnalytics solution offers seamless access to information, a holistic view of our activity, and valuable decision-support tools. Millensys truly listens and delivers.`,
    // },
    // {
    //     name : 'Prof. Magdy Bassiouni',
    //     title : 'Professor Emeritus of Radiology, Cairo Univ',
    //     img : cus_4,
    //     description : `For the past decade, Millensys' RIS and PACS have been the backbone of our radiology department. Writing reports is a breeze thanks to their user-friendly interface, and their top-notch support team is always there to answer any questions.  Millensys is a reliable partner we can count on`,
    // },
]
export const customersFeedback_ar = [
    {
        name: 'د. عبد القادر بنتريا',
        title: 'مؤسس DIAGNOOR SCANLAB',
        img: cus_1,
        description: `نظام RIS و PACS و ERP عبر الويب من ميلينسيس حول سير عملي. الوصول عن بُعد من خلال التطبيب عن بُعد يمكّنني من خدمة المزيد من المرضى، وكل ذلك بفضل النظام المبسط.`,
    },
    {
        name: 'د. فؤاد عثماني',
        title: 'المؤسس المشارك لـ CIM RIM',
        img: cus_2,
        description: `منذ عام 2015، كانت ميلينسيس شريكًا موثوقًا به لمنشأتنا الصحية. قدمت حلولهم لـ RIS و PACS و ERP جودة استثنائية، وكان التزامهم بالدعم غير المشروط لا يقدر بثمن. في الآونة الأخيرة، نجح الترقية بسلاسة في دمج وحدات جديدة مع الحفاظ على سنوات من بيانات المرضى. هذا الجمع بين الابتكار والموثوقية يجعل ميلينسيس شريكًا حقيقيًا في تقديم أفضل رعاية ممكنة.`,
    },
    {
        name: 'أ. د. مجدي بسيوني',
        title: 'أستاذ فخري للأشعة، جامعة القاهرة',
        img: cus_4,
        description: `على مدار العقد الماضي، كان نظام RIS و PACS من ميلينسيس العمود الفقري لقسم الأشعة لدينا. كتابة التقارير أصبحت سهلة بفضل واجهتهم سهلة الاستخدام، وفريق الدعم الممتاز الخاص بهم دائمًا موجود للإجابة على أي أسئلة. ميلينسيس هو شريك موثوق نعتمد عليه.`,
    },
]


